import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { fetchPropertyCounts } from 'src/store/actions/properties';
import ModernizedNotes from 'src/components/Notes/ModernizedNotes';
import { UseNotesAPIReturn } from 'src/SharedCustomHooks/UseNotesAPI/useNotesAPI';

const HIDDEN_ADD_ROLES: string[] = [
  'Strata Manager',
  'Vendor',
  'Home Owner',
  'Realtor',
  'Occupant',
];

interface PropertyNotesProps {
  property: any;
  notesAPI: UseNotesAPIReturn;
}

const PropertyNotes = ({ property, notesAPI }: PropertyNotesProps) => {
  const dispatch = useDispatch();
  const user: any = useSelector(selectAuthenticatedUser);
  const prLoader: any = useSelector(selectPRLoader);

  const refreshCounts = useCallback(() => {
    const userRole: string | undefined = user?.roles?.[0]?.role?.name;

    if (property.propertyId && user?.id && userRole) {
      dispatch(fetchPropertyCounts(property.propertyId, user.id, userRole));
    }
  }, [dispatch, property.propertyId, user]);

  const userRole: string = user?.roles?.[0]?.role?.name || '';
  const canAddNotes: boolean = !HIDDEN_ADD_ROLES.includes(userRole);

  const isLoading: boolean =
    prLoader || (notesAPI.loadingNotes && notesAPI.notes.length === 0);

  return (
    <div className="property-notes-container" style={{ position: 'relative' }}>
      <ModernizedNotes
        notesAPI={notesAPI}
        entityId={property.propertyId}
        itemType="Property"
        userId={user.id}
        canAddNote={canAddNotes}
        canDelete={true}
        loading={isLoading}
        afterMutate={refreshCounts}
        addDialogTitle="Add Property Note"
        editDialogTitle="Edit Property Note"
      />
    </div>
  );
};

export default PropertyNotes;
